import React, { useState } from 'react';
import { Platform } from 'react-native';

import { Box, Text } from '@components/Restyle';
import Button from '@components/shared/Button/Button';
import Icon from '@components/shared/Icon/Icon';
import theme from '@themes/theme';

type Props = {
  t: (key: string) => string;
  onPressAddMember: () => void;
  onPressCopyInviteLine: () => void;
  isAdmin?: boolean;
  disabledButtons?: boolean;
  isLinkCopied?: boolean;
};

export const GroupInviteCard: React.FC<Props> = ({
  disabledButtons,
  onPressAddMember,
  onPressCopyInviteLine,
  t,
  isAdmin = false,
  isLinkCopied = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      borderRadius='m'
      backgroundColor={Platform.OS === 'web' ? 'white' : 'grey01'}
      height={isAdmin ? 216 : 144}
      m='m'
      px='m'
      py='l'>
      <Text
        variant='labelSmall'
        numberOfLines={2}
        textAlign='center'
        color='textPrimary'>
        Welcome to your new group!{'\n'}
        Invite friends whenever you’re ready.
      </Text>

      {isAdmin && (
        <Button
          isSmall={true}
          marginTop='l'
          borderColor={'#000' as any}
          disabled={disabledButtons}
          borderRadius='l'
          height={48}
          backgroundColor='white'
          onPress={() => {
            onPressAddMember();
          }}
          prefix={<Icon name='UserPlus' color='black' variant='m' />}
          prefixMarginRight='m'
          accessibilityLabel={t('models:chat.inviteOrAddMember')}>
          <Text variant='labelSmall' color='black'>
            {t('models:chat.inviteOrAddMember')}
          </Text>
        </Button>
      )}

      <Button
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        isSmall={true}
        variant='edit'
        marginTop='m'
        borderColor={theme.colors.greenSecondary}
        borderRadius='l'
        disabled={disabledButtons || isLinkCopied}
        height={48}
        backgroundColor={isHovered ? 'grey01' : 'white'}
        onPress={() => {
          if (isLinkCopied) return;
          onPressCopyInviteLine();
        }}
        prefix={
          <Icon
            name={isLinkCopied ? 'Check' : 'Link'}
            color='greenSecondary'
            variant='m'
          />
        }
        prefixMarginRight='m'
        accessibilityLabel={t('shared:copyLinkToInvite')}>
        <Text variant='labelSmall' color='greenSecondary'>
          {isLinkCopied ? t('shared:linkCopied') : t('shared:copyLinkToInvite')}
        </Text>
      </Button>
    </Box>
  );
};
